'use client'

/* empty css                                     */
/* empty css                                        */
/* empty css                                     */
/* empty css                                      */
/* empty css                                      */
/* empty css                                         */
import "./src/atomic/sprinkles.ts.vanilla.css.js";
/* empty css                                          */
var visuallyHidden = "c4-84-8_1lxmpax1 c4-84-8_1lxmpax0 c4-84-8_nly6ul33 c4-84-8_nly6ul35 c4-84-8_161xunp8 c4-84-8_161xunp24 c4-84-8_161xunp40 c4-84-8_161xunp5w c4-84-8_161xunp7s c4-84-8_161xunp9o c4-84-8_161xunpbk c4-84-8_161xunpdg c4-84-8_nly6ulo c4-84-8_zqwrxxr";
var fillParent = "c4-84-8_1lxmpax5 c4-84-8_1lxmpax4 c4-84-8_nly6ulo c4-84-8_1lxmpax3 c4-84-8_1lxmpax2 c4-84-8_nly6ul3b c4-84-8_nly6ul3e c4-84-8_nly6ul3c c4-84-8_nly6ul3d";
var fillParentAfter = "c4-84-8_1lxmpax6";
var fillScreen = "c4-84-8_1lxmpax8 c4-84-8_1lxmpax7 c4-84-8_nly6uls c4-84-8_1lxmpax3 c4-84-8_1lxmpax2 c4-84-8_nly6ul3b c4-84-8_nly6ul3e c4-84-8_nly6ul3c c4-84-8_nly6ul3d";
var absoluteCentered = "c4-84-8_1lxmpaxa c4-84-8_1lxmpax9 c4-84-8_nly6ulo c4-84-8_nly6ul4";
var chalkFocusRules = { high: { boxShadow: "white 0px 0px 0px 4px, #2A4ECC 0px 0px 0px 6px, #2A4ECC 0px 0px 1px 6px" }, medium: { boxShadow: "#2A4ECC 0px 0px 0px 2px, white 0px 0px 0px 3px" }, low: { boxShadow: "#2A4ECC 0px 0px 0px 2px" } };
var chalkFocus = { high: "c4-84-8_1lxmpaxb", medium: "c4-84-8_1lxmpaxc", low: "c4-84-8_1lxmpaxd" };
var chalkFocusWithin = { high: "c4-84-8_1lxmpaxe", medium: "c4-84-8_1lxmpaxf", low: "c4-84-8_1lxmpaxg" };
var chalkFocusWithActiveOutline = { high: "c4-84-8_1lxmpaxh", medium: "c4-84-8_1lxmpaxi", low: "c4-84-8_1lxmpaxj" };
export {
  absoluteCentered,
  chalkFocus,
  chalkFocusRules,
  chalkFocusWithActiveOutline,
  chalkFocusWithin,
  fillParent,
  fillParentAfter,
  fillScreen,
  visuallyHidden
};
